<template>
    <div class="tfa-verify">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">Verifikasi Two-Factor Authentication (2FA)</div>
              <div class="card-body">
                <form @submit.prevent="submitOtp">
                  <div class="form-group">
                    <label for="otp">Masukkan OTP dari aplikasi Google Authenticator</label>
                    <input
                      type="number"
                      v-model="otp"
                      class="form-control"
                      id="otp"
                      placeholder="Masukkan OTP"
                      required
                      autofocus
                    />
                  </div>
                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn btn-primary"
                    >Verifikasi
                    </button>
                  </div>
                </form>
                <div v-if="errorMessage" class="alert alert-danger">
                  {{ errorMessage }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        otp: '',
        loading: false,
        errorMessage: null,
        username: '',
        password: ''
      }
    },
    methods: {
      submitOtp () {
        this.loading = true
        this.errorMessage = null
        const otpData = {
          otp: this.otp,
          USER_NAME: localStorage.getItem('USER_NAME'),
          password: localStorage.getItem('password')
        }
  
        // Kirim OTP ke backend
        this.$http.post('otentikasi/signin', otpData)
          .then((response) => {
            if (response.data.error) {
              this.errorMessage = response.data.error
            } else {
              // Jika berhasil, simpan token dan redirect ke dashboard
              this.$store.dispatch('auth/attempt', response.data.token).then(() => {
                let nextUrl = this.$route.query.redirect == null ? '/dashboard' : this.$route.query.redirect
                // console.log(nextUrl)
                this.$router.push(nextUrl)
              })
            }
          })
      }
    }
  }
  </script>
  
  <style scoped>
  .tfa-verify {
    margin-top: 50px;
  }
  
  .card-header {
    text-align: center;
    font-weight: bold;
  }
  
  .card-body {
    padding: 20px;
  }
  
  .alert {
    margin-top: 15px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/Tfaverify.vue?fbc3f3aa